import React from 'react';
import {render} from 'react-dom';
import {App} from './components';
import {KP, BASE_URL, WS_STR} from './settings';
import appParams from '../params.json';

render(
    <App base_url={BASE_URL} kp={KP} ws_str={WS_STR} psId={appParams}/>,
    document.getElementById('scadamainapp'),
);



// WEBPACK FOOTER //
// ./src/index.js